import {MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH} from "../constans";
import {CookieOptions} from "../types";

export class Helpers {

    /**
     * Установить скролл для страницы
     * @param isOverflow
     */
    public static setOverflowHtml(isOverflow: boolean): void
    {
        const bodySelector = 'body';

        isOverflow ?
            $(bodySelector).addClass('overflow-hidden')
            :
            $(bodySelector).removeClass('overflow-hidden');
    }

    /**
     * Скролит страницу элементу
     */
    public static scrollTo(selector: string|HTMLElement, gap = 100): void {
        let element: HTMLElement | null = null;

        if (typeof selector === 'string') {
            if (!document || !document.querySelector(selector)) {
                return;
            }
            element = document.querySelector(selector);
        } else {
            element = selector;
        }

        const offsetTop: number = (element as HTMLHtmlElement).getBoundingClientRect().top + window.scrollY;

        window.scroll({
            top: offsetTop - gap,
            behavior: "smooth",
        });
    }

    /**
     * Устройство таблет
     * @private
     */
    static isTablet(width: number|null = null): boolean
    {
        return (width ?? window.innerWidth) < MAX_TABLET_WIDTH;
    }

    /**
     * Устройство мобильный
     * @private
     */
    static isMobile(): boolean
    {
        return window.innerWidth < MAX_MOBILE_WIDTH;
    }

    /**
     * Вершина блока в области просмотра
     * @param $block
     */
    static isTopInViewPort($block: JQuery): boolean
    {
        const holder = $block.get(0);

        return !holder || holder.getBoundingClientRect().top > 0;
    }

    /**
     * Клик вне блока
     * @param event
     * @param $block
     */
    static isOutsideClick(event: JQuery.ClickEvent | Event, $block: JQuery): boolean
    {
        const $target = $(event.target);
        return (!$target.closest($block).length);
    }

    static getCookie(name: string): string|null
    {
        const matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }

    static setCookie(name: string, value: string, options: CookieOptions|null = null): void
    {
        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        if (options.expires && typeof options.expires === 'number') {
            var d = new Date();
            d.setTime(d.getTime() + options.expires * 1000);
            options.expires = options.expires = d;
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    static changeInputValueByCheckbox($field: JQuery): void {
        const $input = $field.find('input[type="hidden"]');
        $field.on('change', 'input[type="checkbox"]', (event) => {
            const $target = $(event.target);
            const value = $target.is(':checked')
                ? $target.data('checked') : $target.data('unchecked');
            $input.val(value);
        });
    }

    static hasFiltersValue(params: JQuery.NameValuePair[]): boolean {
        if (!params.length) {
            return false;
        }

        let hasValue = false;

        params.forEach((item) => {
            if (!item.value) {
                return;
            }

            hasValue = true;
        });

        return hasValue;
    }
}
